module.exports = __webpack_public_path__ + "img/3.ce0df2a2.png";